// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fV7h","content":"styles_content__1fFIg","row":"styles_row__fWJ3W","footer":"styles_footer__37v7P","phraseLength":"styles_phraseLength__2x9yZ"};